import React from 'react';
import { Star, Shield, Lock, Zap } from 'lucide-react';
import { PaymentLogos } from './PaymentLogos';
export function PricingGuarantee() {
  return <section className="bg-[#0a0a0a] py-12 sm:py-20 px-6 relative overflow-hidden border-t border-gray-900/60" data-id="element-179">
      {/* Ambient glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[#DC2626]/[0.05] rounded-full blur-[140px] pointer-events-none" data-id="element-180" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-[#d4a85a]/[0.04] rounded-full blur-[120px] pointer-events-none" data-id="element-181" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-182">
        {/* Header */}
        <div className="text-center mb-16 flex flex-col items-center gap-6" data-id="element-183">
          <p className="text-[#d4a85a] uppercase tracking-[0.25em] text-[11px] sm:text-xs font-semibold" data-id="element-184">
            The Moment Is Now
          </p>

          <h2 className="font-serif text-4xl sm:text-5xl lg:text-[56px] text-[#e8e2d4] font-normal leading-[1.15]" data-id="element-185">
            The story of <span className="text-[#d4a85a]" data-id="element-186">Venezuela</span>
            <br data-id="element-187" />
            deserves to be read.
          </h2>

          <p className="font-serif italic text-[#e8e2d4] text-lg sm:text-xl leading-relaxed font-light mt-2" data-id="element-188">
            Do not let time erase what happened. Do not let silence win.
          </p>

          <p className="text-gray-400 text-base sm:text-lg" data-id="element-189">
            A book that will change your perspective forever.
          </p>
        </div>

        {/* Offer Box */}
        <div className="bg-[#0d0d0d] border border-[#d4a85a]/20 rounded-2xl p-8 sm:p-12 shadow-[0_0_60px_rgba(0,0,0,0.5)] flex flex-col items-center text-center gap-6" data-id="element-190">
          {/* Rating */}
          <div className="flex items-center gap-3" data-id="element-191">
            <div className="flex gap-1" data-id="element-192">
              {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-4 h-4 fill-[#d4a85a] text-[#d4a85a]" data-id="element-193" />)}
            </div>
            <span className="text-sm text-gray-400" data-id="element-194">
              based on +16000 readers
            </span>
          </div>

          {/* Social proof */}
          <p className="font-serif italic text-[#e8e2d4]/90 text-base sm:text-lg leading-relaxed max-w-xl" data-id="element-195">
            Thousands of people already have their copy. The question is whether
            you will have yours.
          </p>

          {/* Pricing block */}
          <div className="flex flex-col items-center gap-3 pt-2" data-id="element-196">
            <div className="flex items-center gap-3" data-id="element-197">
              <span className="text-xl text-gray-500 line-through font-light" data-id="element-198">
                $39.99
              </span>
              <span className="bg-[#DC2626] text-white text-[11px] font-bold tracking-wider px-2.5 py-1 rounded shadow-[0_0_10px_rgba(220,38,38,0.4)]" data-id="element-199">
                50% OFF
              </span>
            </div>

            <div className="font-serif text-[#d4a85a] text-6xl sm:text-7xl font-bold leading-none drop-shadow-[0_0_20px_rgba(212,168,90,0.2)]" data-id="element-200">
              $19.99
            </div>

            <p className="text-sm text-gray-500 italic mt-1" data-id="element-201">
              Available in digital format (PDF/EPUB)
            </p>
          </div>

          {/* Guarantee Box */}
          <div className="w-full mt-4 border border-[#d4a85a]/30 rounded-lg p-5 flex items-start gap-4 text-left bg-black/40" data-id="element-202">
            <Shield className="w-5 h-5 text-[#d4a85a] flex-shrink-0 mt-0.5" strokeWidth={1.5} data-id="element-203" />
            <p className="text-sm sm:text-[15px] text-gray-300 leading-relaxed" data-id="element-204">
              <strong className="text-[#e8e2d4] font-semibold" data-id="element-205">
                14-Day Guarantee.
              </strong>{' '}
              If you are not moved by this document, we will refund your money.
              No questions asked.
            </p>
          </div>

          {/* CTA Button */}
          <a href="https://templeofpages.com/cart/49184174768371:1" className="w-full block bg-[#DC2626] hover:bg-[#b91c1c] text-white font-bold py-5 px-8 rounded text-base sm:text-lg transition-all duration-300 shadow-[0_0_30px_rgba(220,38,38,0.3)] hover:shadow-[0_0_45px_rgba(220,38,38,0.5)] hover:-translate-y-1 tracking-wide uppercase mt-2 text-center no-underline" data-id="element-206">
            Read the Full Book — $19.99
          </a>

          <PaymentLogos data-id="element-207" />

          {/* Trust lines */}
          <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6 text-xs sm:text-sm text-gray-500 pt-2" data-id="element-208">
            <div className="flex items-center gap-2" data-id="element-209">
              <Lock className="w-4 h-4" data-id="element-210" />
              <span data-id="element-211">256-bit SSL Encryption</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-212">
              <Zap className="w-4 h-4" data-id="element-213" />
              <span data-id="element-214">Automated delivery to your email</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}